import { LoaderFunctionArgs, redirect } from 'react-router-dom';
import { setPendingDesktopLaunch } from 'shared/services/local-storage';
import { getDesktopDownload } from 'shared/utils/get-desktop-download';
import { getMobileStoreLink } from 'shared/utils/get-mobile-store-link';
import { getOpenInAppTarget } from 'shared/utils/get-open-in-app-target';

// A mobile browser landing here means the universal link found no installed app.
export const openInAppLoader = ({ params, request }: LoaderFunctionArgs) => {
  const linkPath = `${params['*'] ?? ''}${new URL(request.url).search}`;
  const { webPath } = getOpenInAppTarget(linkPath);

  if (window.electron) {
    return redirect(webPath);
  }

  const storeLink = getMobileStoreLink();
  if (storeLink) {
    return redirect(storeLink);
  }

  if (getDesktopDownload()) {
    setPendingDesktopLaunch(linkPath);
  }
  return redirect(webPath);
};
